// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ah","heading":"Bh","items":"Ch","featureCss":"Dh","disabled":"Eh","imgCss":"Fh"};